<template>
  <div
    v-if="blok.name"
    v-editable="blok"
    class="practice-leads__list-item col-12 col-md-6 col-lg-4"
  >
    <div class="practise-leads__list-item-row row align-items-center">
      <div v-if="blok.image" class="col-5 col-lg-12">
        <component
          :is="'a_imageSource' | dashify"
          :blok="blok"
          :image-url="blok.image"
          :alt="blok.title || 'lead picture'"
        />
      </div>
      <div class="col-7 col-lg-12">
        <p class="practice-leads__list-title">
          {{ blok.title }}
        </p>
        <p class="practice-leads__list-person">
          {{ blok.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
